import { Link } from 'react-router-dom';
import { articles } from '@/mocks/sports';

export default function LatestNews() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              最新资讯
            </h2>
            <p className="text-sm text-foreground-600">专业赛事分析，深度体育资讯</p>
          </div>
          <Link
            to="/article/article-1"
            className="flex items-center gap-1.5 text-sm font-label font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            更多资讯
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.slice(0, 6).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="h-44 md:h-48 w-full relative overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-700 text-xs font-label font-medium">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-time-line text-xs"></i>
                  </div>
                  <span>{article.readTime} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}